import Offer from "../components/offer";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { slugCombine } from '../utils/slugManager';
export function OfferSections({ title, offersList, type, showMore = true, isVehicleOnline = false }) {
    const { t: trans, i18n } = useTranslation(["common"]);
    let lang = (i18n.language || 'ar');
    const languageDir = "language-" + lang;

    useEffect(() => {
        if (isVehicleOnline) return;
        if (offersList && offersList.length > 0) {
            import("../services/trackingUserEvents").then(tracking => {
                const items = offersList.map((offer, index) => ({
                    promotion_id: offer?.slug || offer?.id,
                    promotion_name: offer?.title,
                    creative_name: "offer_section",
                    creative_slot: "offer_section_slot_" + index,
                    location_id: "offer_section_location",
                }));
                tracking.trackViewPromotion(items);
            });
        }
    }, [offersList, isVehicleOnline]);

    if (offersList == null || offersList.length === 0)
        return null;
    return (
        <div className={"container mb-32 " + languageDir}>
            <h2 className={"text-20 font-bold mb-16"}>{title}</h2>
            <div className="grid gap-2 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4   mb-16 ">
                {
                    offersList?.map((offer, index) => {
                        return (
                            <Offer
                                key={index}
                                name={offer?.title}
                                img={offer?.image ? offer?.image : '/assets/images/parts/default.png'}
                                type={offer?.type}
                                excerpt={offer?.excerpt}
                                endDate={offer?.endDate}
                                startDate={offer?.startDate}
                                totalDays={offer?.totalDays}
                                slug={slugCombine(offer?.slug, offer?.otherLink)}
                            />
                        );
                    })
                }
            </div>
            {
                showMore ?
                    offersList?.length === 4 ?
                        <div className="text-left">
                            <Link to={"/offers/type/" + type} className={"link-btn-white"}>
                                {trans("common:show-more")}
                            </Link>
                        </div>
                        : null
                    : null
            }

        </div>
    );
}